import React, { Component } from "react"
import PropTypes from "prop-types"

export default class Drilldown extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    title: PropTypes.string,
  }

  static defaultProps = {
    children: "",
    className: "",
    title: "",
  }

  render() {
    return (
      <div {...this.props} className={"common-drilldown " + this.props.className}>
        <div className="title">{this.props.title}</div>

        {this.props.children}
      </div>
    )
  }
}

export const referenceComparator = (a, b) => {
  const aParts = a.reference.split(".")
  const bParts = b.reference.split(".")
  const len = Math.max(aParts.length, bParts.length)
  for (let i = 0; i < len; i++) {
    const [ai, bi] = [aParts[i], bParts[i]]

    let diff
    if (ai === undefined) diff = -1
    else if (bi === undefined) diff = 1
    else if (Number.isSafeInteger(Number(ai)) && Number.isSafeInteger(Number(bi))) diff = Number(ai) - Number(bi)
    else diff = String(ai).localeCompare(String(bi))

    if (diff !== 0) return diff
  }
  return 0
}



// WEBPACK FOOTER //
// ./src/features/common/Drilldown.js